import type { CURRENCYCODETYPE, CURRENCYSYMBOLTYPE, FXCONVERSION_TYPE, FXRATE_TYPE } from 'BreetHelpers';

export interface IFiatTransactionDetailsProps {
	amount: string;
	fxRate?: FXRATE_TYPE;
	fromCurrencyCode: CURRENCYCODETYPE;
	toCurrencyCode: CURRENCYCODETYPE;
}

export type fiatTransactionType = 'sell-usd' | 'fiat-to-usd' | 'swap-currency';

export const fiatTransactionTypeObject: Record<FXCONVERSION_TYPE, fiatTransactionType> = {
	NGNToGHS: 'swap-currency',
	GHSToNGN: 'swap-currency',
	FiatToUSD: 'fiat-to-usd',
	SellUSD: 'sell-usd',
};

export interface IFiatTransactionDetailsViewProps {
	amount: string;
	handleVerification: () => void;
	symbol: CURRENCYSYMBOLTYPE;
	isLoading?: boolean;
	rate: string;
	expectedFiat: {
		amount: string;
		currencyCode: CURRENCYCODETYPE;
	};
	balance: {
		amount: string;
		currencyCode: CURRENCYCODETYPE;
	};
}
